import { Sparkles, Globe, Star, BarChart3 } from "lucide-react";

export type VideoType = "explainer" | "product-launch" | "testimonials" | "data-viz";

interface VideoTypeOption {
  id: VideoType;
  label: string;
  description: string;
  icon: React.ReactNode;
  available: boolean;
}

const VIDEO_TYPES: VideoTypeOption[] = [
  {
    id: "explainer",
    label: "Explainer",
    description: "Edukacyjny film wyjaśniający temat — animowane slajdy z AI",
    icon: <Sparkles size={24} />,
    available: true,
  },
  {
    id: "product-launch",
    label: "Product Launch",
    description: "Prezentacja produktu na bazie URL strony",
    icon: <Globe size={24} />,
    available: false,
  },
  {
    id: "testimonials",
    label: "Testimoniale",
    description: "Animowane opinie klientów z Google Reviews",
    icon: <Star size={24} />,
    available: false,
  },
  {
    id: "data-viz",
    label: "Data Viz",
    description: "Wizualizacja danych i statystyk",
    icon: <BarChart3 size={24} />,
    available: false,
  },
];

interface VideoTypePickerProps {
  onSelect: (type: VideoType) => void;
}

export default function VideoTypePicker({ onSelect }: VideoTypePickerProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      {VIDEO_TYPES.map((vt) => (
        <button
          key={vt.id}
          onClick={() => vt.available && onSelect(vt.id)}
          disabled={!vt.available}
          className={`
            relative flex flex-col items-start gap-3 p-5 rounded-xl border text-left transition
            ${
              vt.available
                ? "border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.06] hover:border-[#ef3e29]/40 cursor-pointer"
                : "border-white/[0.04] bg-white/[0.01] opacity-40 cursor-not-allowed"
            }
          `}
        >
          <div
            className={`
            w-12 h-12 rounded-lg flex items-center justify-center
            ${vt.available ? "bg-[#ef3e29]/20 text-[#ef3e29]" : "bg-white/[0.06] text-white/30"}
          `}
          >
            {vt.icon}
          </div>
          <div>
            <div className="text-sm font-semibold text-white">{vt.label}</div>
            <div className="text-xs text-white/40 mt-1 leading-relaxed">{vt.description}</div>
          </div>
          {!vt.available && (
            <span className="absolute top-3 right-3 text-[10px] px-2 py-0.5 rounded-full bg-white/[0.06] text-white/30">
              Wkrótce
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
